import React, { useCallback, useContext } from 'react';
import { Button } from '@vodafoneis/sjonvarpskjarni-js-lib';
import { PlaybackInformationContext } from '../../../../contexts/PlaybackInformationContext';

export const PlaybackSettingsFullscreen: React.FC = () => {
	const { player } = useContext(PlaybackInformationContext);

	const onFullscreenButtonPressed = useCallback(
		(event) => {
			event.preventDefault();
			event.stopPropagation();
			player.toggleFullscreen();
		},
		[player]
	);

	if (!player || !player.supportsFullscreen()) return null;

	return <Button className={'playback-settings-fullscreen'} onClick={onFullscreenButtonPressed} />;
};
